(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FOOTER-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const query = window.matchMedia('(max-width: 749px)');
    const menus = () => document.querySelectorAll('.footer-2--collapse-mobile .footer-2__menu');
    const syncMenus = () => {
      menus().forEach((menu) => {
        if (query.matches) {
          menu.removeAttribute('open');
        } else {
          menu.setAttribute('open', '');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncMenus);
    } else {
      syncMenus();
    }

    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', syncMenus);
    } else if (typeof query.addListener === 'function') {
      query.addListener(syncMenus);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-fixed-offer')) {
    customElements.define('lorzor-fixed-offer', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.cleanup?.abort();
        clearTimeout(this.resetTimer);
        this.attempt = (this.attempt || 0) + 1;
        this.cleanup = new AbortController();
        this.button = this.querySelector('[data-copy]');
        this.code = this.querySelector('[data-code]');
        this.feedback = this.querySelector('[data-feedback]');
        if (!this.button || !this.code) return;
        this.button.hidden = false;
        this.button.disabled = false;
        this.resetLabels();
        this.button.addEventListener('click', () => this.copyCode(), { signal: this.cleanup.signal });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resetTimer);
        this.cleanup?.abort();
        this.attempt = (this.attempt || 0) + 1;
      }
      resetLabels() {
        this.button.querySelector('[data-copy-label]').hidden = false;
        this.button.querySelector('[data-copied-label]').hidden = true;
        this.feedback.textContent = '';
      }
      selectCode() {
        const selection = window.getSelection();
        if (!selection) return false;
        const range = document.createRange();
        range.selectNodeContents(this.code);
        selection.removeAllRanges();
        selection.addRange(range);
        return true;
      }
      async copyCode() {
        const attempt = ++this.attempt;
        const code = this.code.textContent.trim();
        if (!code) return;
        this.button.disabled = true;
        clearTimeout(this.resetTimer);
        this.resetLabels();
        let copied = false;
        try {
          if (navigator.clipboard?.writeText) {
            try { await navigator.clipboard.writeText(code); copied = true; } catch {}
          }
          if (!this.isConnected || attempt !== this.attempt) return;
          if (!copied && this.selectCode()) {
            try { copied = Boolean(document.execCommand?.('copy')); } catch {}
          }
          if (!this.isConnected || attempt !== this.attempt) return;
          if (copied) {
            this.button.querySelector('[data-copy-label]').hidden = true;
            this.button.querySelector('[data-copied-label]').hidden = false;
            this.feedback.textContent = this.dataset.success;
          } else {
            this.feedback.textContent = this.dataset.failure;
          }
        } finally {
          if (this.isConnected && attempt === this.attempt) {
            this.button.disabled = false;
            this.resetTimer = setTimeout(() => { if (this.isConnected) this.resetLabels(); }, 7000);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-home-lifestyle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-home-lifestyle')) {
    customElements.define('lz-home-lifestyle', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-life-viewport]');
        this.prev = this.querySelector('[data-life-prev]');
        this.next = this.querySelector('[data-life-next]');
        this.thumb = this.querySelector('[data-life-progress]');
        if (!this.viewport) return;
        this.onScroll = () => this.update();
        this.onResize = () => this.update();
        this.onKeydown = event => { if (event.target !== this.viewport) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1); } };
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);
        this.onBlockSelect = event => { if (this.contains(event.target)) event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); };
        this.onPointerDown = event => { if (event.pointerType !== 'mouse' || event.button !== 0) return; this.dragStartX = event.clientX; this.dragStartScroll = this.viewport.scrollLeft; this.dragging = false; };
        this.onPointerMove = event => { if (this.dragStartX == null) return; const distance = event.clientX - this.dragStartX; if (Math.abs(distance) > 5) this.dragging = true; if (this.dragging) { event.preventDefault(); this.viewport.scrollLeft = this.dragStartScroll - distance; } };
        this.onPointerUp = () => { if (this.dragging) { this.suppressClick = true; requestAnimationFrame(() => { this.suppressClick = false; }); } this.dragStartX = null; this.dragging = false; };
        this.onClickCapture = event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); } };
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        if ('ResizeObserver' in window) { this.observer = new ResizeObserver(this.onResize); this.observer.observe(this.viewport); this.observer.observe(this.viewport.firstElementChild); }
        else window.addEventListener('resize', this.onResize);
        requestAnimationFrame(() => this.update());
      }
      disconnectedCallback() {
        if (!this.viewport) return;
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('click', this.onClickCapture, true);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.observer?.disconnect();
        window.removeEventListener('resize', this.onResize);
      }
      step(direction) {
        const card = this.viewport.querySelector('.lz-life__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.viewport.firstElementChild).gap) || 0;
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const position = Math.min(max, Math.abs(this.viewport.scrollLeft));
        if (this.prev) this.prev.disabled = position < 2;
        if (this.next) this.next.disabled = position >= max - 2;
        if (this.thumb) { const visible = Math.min(1, this.viewport.clientWidth / Math.max(1, this.viewport.scrollWidth)); this.thumb.style.width = `${visible * 100}%`; this.thumb.style.transform = `translateX(${max ? position / max * (1 - visible) * 100 / visible : 0}%)`; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-home-proof-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-home-proof-tabs')) {
    customElements.define('lz-home-proof-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-proof-tab]')];
        this.onClick = event => { const tab = event.target.closest('[data-proof-tab]'); if (tab && this.contains(tab)) this.activate(tab); };
        this.onKeydown = event => {
          const tab = event.target.closest('[data-proof-tab]');
          if (!tab || !this.contains(tab)) return;
          const index = this.tabs.indexOf(tab);
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(this.tabs[next], true);
        };
        this.onBlockSelect = event => { const tab = event.target.closest('[data-proof-tab]'); if (tab && this.contains(tab)) this.activate(tab); };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      activate(selected, focus = false) {
        this.tabs.forEach(tab => { const active = tab === selected; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        this.querySelectorAll('.lz-proof__panel').forEach(panel => { panel.hidden = panel.id !== selected.dataset.target; });
        if (focus) selected.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-home-reviews')) {
    customElements.define('lz-home-reviews', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-review-viewport]');
        if (!this.viewport) return;
        this.prev = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.progress = this.querySelector('[data-review-progress]');
        this.onScroll = () => this.update();
        this.onResize = () => this.update();
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);
        this.onKeydown = event => { if (event.target === this.viewport && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) { event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1); } };
        this.onBlockSelect = event => { if (this.contains(event.target)) event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); };
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        if ('ResizeObserver' in window) { this.resizeObserver = new ResizeObserver(this.onResize); this.resizeObserver.observe(this.viewport); } else { window.addEventListener('resize', this.onResize); }
        this.update();
      }
      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        this.viewport?.removeEventListener('keydown', this.onKeydown);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.onResize);
      }
      step(direction) {
        const card = this.querySelector('.lz-reviews__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.querySelector('.lz-reviews__track')).gap) || 0;
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const position = Math.max(0, Math.min(max, this.viewport.scrollLeft));
        if (this.prev) this.prev.disabled = position < 2;
        if (this.next) this.next.disabled = position >= max - 2;
        if (this.progress) {
          const visible = this.viewport.scrollWidth ? Math.min(1, this.viewport.clientWidth / this.viewport.scrollWidth) : 1;
          this.progress.style.width = `${visible * 100}%`;
          this.progress.style.transform = `translateX(${max ? position / max * (1 - visible) * 100 / visible : 0}%)`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-media-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-media-tabs')) {
    customElements.define(
      'lorzor-media-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-lmt-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-lmt-panel]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab, false));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
          });

          this.onBlockSelect = (event) => {
            const panel = event.target.closest('[data-lmt-panel]');
            if (!panel || !this.contains(panel)) return;
            const tab = this.tabs.find((item) => item.getAttribute('aria-controls') === panel.id);
            if (tab) this.activate(tab, false);
          };

          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        activate(activeTab, moveFocus) {
          this.tabs.forEach((tab) => {
            const isActive = tab === activeTab;
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
          });

          if (moveFocus) activeTab.focus();
        }

        onKeydown(event, currentTab) {
          const currentIndex = this.tabs.indexOf(currentTab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          if (nextIndex !== currentIndex) {
            event.preventDefault();
            this.activate(this.tabs[nextIndex], true);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-contact-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scriptUrl = 'https://www.17track.net/externalcall.js';
    let trackingScriptPromise;

    const loadTrackingScript = () => {
      if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
        return Promise.resolve();
      }

      if (trackingScriptPromise) {
        return trackingScriptPromise;
      }

      trackingScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

        if (existingScript) {
          if (existingScript.dataset.loaded === 'true') {
            resolve();
            return;
          }
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          window.setTimeout(() => {
            if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
              resolve();
            }
          }, 1500);
          return;
        }

        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return trackingScriptPromise;
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-support-tracking-form]');

      if (!form) {
        return;
      }

      event.preventDefault();

      const input = form.querySelector('input[name="tracking_number"]');
      const error = form.querySelector('[data-support-tracking-error]');
      const result = document.getElementById(form.dataset.resultId);
      const trackingNumber = input ? input.value.trim() : '';

      if (!trackingNumber) {
        if (error) {
          error.hidden = false;
        }
        if (input) {
          input.focus();
        }
        return;
      }

      if (error) {
        error.hidden = true;
      }

      if (result) {
        result.innerHTML = '';
      }

      loadTrackingScript()
        .then(() => {
          if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
            throw new Error('17TRACK widget unavailable');
          }

          window.YQV5.trackSingle({
            YQ_ContainerId: form.dataset.resultId,
            YQ_Height: Number(form.dataset.height) || 560,
            YQ_Fc: form.dataset.carrier || '0',
            YQ_Lang: form.dataset.language || 'en',
            YQ_Num: trackingNumber
          });
        })
        .catch(() => {
          if (error) {
            error.textContent = 'Tracking is temporarily unavailable. Please try again later or contact support.';
            error.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-hero-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scriptUrl = 'https://www.17track.net/externalcall.js';
    let trackingScriptPromise;

    const loadTrackingScript = () => {
      if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
        return Promise.resolve();
      }

      if (trackingScriptPromise) {
        return trackingScriptPromise;
      }

      trackingScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

        if (existingScript) {
          if (existingScript.dataset.loaded === 'true') {
            resolve();
            return;
          }
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          window.setTimeout(() => {
            if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
              resolve();
            }
          }, 1500);
          return;
        }

        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return trackingScriptPromise;
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-support-hero-tracking-form]');

      if (!form) {
        return;
      }

      event.preventDefault();

      const input = form.querySelector('input[name="tracking_number"]');
      const error = form.querySelector('[data-support-hero-tracking-error]');
      const result = document.getElementById(form.dataset.resultId);
      const trackingNumber = input ? input.value.trim() : '';

      if (!trackingNumber) {
        if (error) {
          error.hidden = false;
        }
        if (input) {
          input.focus();
        }
        return;
      }

      if (error) {
        error.hidden = true;
      }

      if (result) {
        result.innerHTML = '';
      }

      loadTrackingScript()
        .then(() => {
          if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
            throw new Error('17TRACK widget unavailable');
          }

          window.YQV5.trackSingle({
            YQ_ContainerId: form.dataset.resultId,
            YQ_Height: Number(form.dataset.height) || 560,
            YQ_Fc: form.dataset.carrier || '0',
            YQ_Lang: form.dataset.language || 'en',
            YQ_Num: trackingNumber
          });
        })
        .catch(() => {
          if (error) {
            error.textContent = 'Tracking is temporarily unavailable. Please try again later or contact support.';
            error.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-use-cases')) {
    customElements.define(
      'lorzor-use-cases',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-luc-viewport]');
          this.track = this.querySelector('[data-luc-track]');
          this.cards = Array.from(this.querySelectorAll('[data-luc-card]'));
          this.previousButton = this.querySelector('[data-luc-previous]');
          this.nextButton = this.querySelector('[data-luc-next]');
          this.slidesPerClick = Number(this.dataset.slidesPerClick || 1);
          this.drag = null;
          this.didDrag = false;

          if (!this.viewport || !this.track || this.cards.length === 0) return;

          this.onPrevious = () => this.scrollByCards(-this.slidesPerClick);
          this.onNext = () => this.scrollByCards(this.slidesPerClick);
          this.onScroll = () => this.requestControlUpdate();
          this.onKeydown = (event) => this.handleKeydown(event);
          this.onPointerDown = (event) => this.handlePointerDown(event);
          this.onPointerMove = (event) => this.handlePointerMove(event);
          this.onPointerUp = (event) => this.handlePointerUp(event);
          this.onClickCapture = (event) => {
            if (!this.didDrag) return;
            event.preventDefault();
            event.stopPropagation();
            this.didDrag = false;
          };
          this.onBlockSelect = (event) => {
            const card = event.target.closest('[data-luc-card]');
            if (!card || !this.contains(card)) return;
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          };

          this.previousButton?.addEventListener('click', this.onPrevious);
          this.nextButton?.addEventListener('click', this.onNext);
          this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.onKeydown);
          this.viewport.addEventListener('pointerdown', this.onPointerDown);
          this.viewport.addEventListener('pointermove', this.onPointerMove);
          this.viewport.addEventListener('pointerup', this.onPointerUp);
          this.viewport.addEventListener('pointercancel', this.onPointerUp);
          this.viewport.addEventListener('click', this.onClickCapture, true);
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.updateControls());
            this.resizeObserver.observe(this.viewport);
          } else {
            this.onWindowResize = () => this.updateControls();
            window.addEventListener('resize', this.onWindowResize);
          }
          this.updateControls();
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.onPrevious);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.viewport?.removeEventListener('scroll', this.onScroll);
          this.viewport?.removeEventListener('keydown', this.onKeydown);
          this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport?.removeEventListener('pointermove', this.onPointerMove);
          this.viewport?.removeEventListener('pointerup', this.onPointerUp);
          this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
          this.viewport?.removeEventListener('click', this.onClickCapture, true);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.resizeObserver?.disconnect();
          if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
          if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
        }

        cardStep() {
          const card = this.cards[0];
          if (!card) return this.viewport.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
          return card.getBoundingClientRect().width + gap;
        }

        scrollByCards(count) {
          this.viewport.scrollBy({ left: this.cardStep() * count, behavior: 'smooth' });
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.scrollByCards(event.key === 'ArrowRight' ? 1 : -1);
        }

        handlePointerDown(event) {
          if (event.pointerType === 'touch' || event.button !== 0) return;
          event.preventDefault();
          this.drag = { id: event.pointerId, startX: event.clientX, startScroll: this.viewport.scrollLeft };
          this.didDrag = false;
          this.viewport.setPointerCapture(event.pointerId);
          this.viewport.classList.add('is-dragging');
        }

        handlePointerMove(event) {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          event.preventDefault();
          const delta = event.clientX - this.drag.startX;
          if (Math.abs(delta) > 5) this.didDrag = true;
          this.viewport.scrollLeft = this.drag.startScroll - delta;
        }

        handlePointerUp(event) {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          this.viewport.classList.remove('is-dragging');
          this.drag = null;
          this.requestControlUpdate();
          window.setTimeout(() => {
            if (!this.didDrag) return;
            this.didDrag = false;
          }, 0);
        }

        requestControlUpdate() {
          if (this.controlFrame) return;
          this.controlFrame = requestAnimationFrame(() => {
            this.controlFrame = null;
            this.updateControls();
          });
        }

        updateControls() {
          if (!this.viewport) return;
          const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.viewport.scrollLeft >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
